<section class="projects-area pb-70">
    <div class="container">
        <div
            class="section-title"
            *ngFor="let sectionTitleContent of sectionTitle"
        >
            <h2>{{ sectionTitleContent.title }}</h2>
        </div>

        <div class="row">
            <div
                class="col-lg-4 col-md-6"
                *ngFor="let singleProjectsContent of singleProjectsBox"
            >
                <div class="single-projects-box">
                    <div class="image">
                        <img
                            [src]="singleProjectsContent.img"
                            alt="image"
                            [class]="singleProjectsContent.imgClass"
                        />

                        <a
                            href="{{ singleProjectsContent.link }}"
                            target="_blank"
                            class="link-btn"
                            ><i class="{{ singleProjectsContent.icon }}"></i
                        ></a>
                    </div>

                    <div class="content">
                        <h3>
                            <a
                                href="{{ singleProjectsContent.link }}"
                                target="_blank"
                                >{{ singleProjectsContent.title }}</a
                            >
                        </h3>
                        <span>{{ singleProjectsContent.subTitle }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
